Shopify.theme.jsCart = {
  init: function ($section) {
    this.$section = $section;
    $(document).off('click.giftboxCart')
      .on('click.giftboxCart', '[data-cart-page-delete], .linkedDeleteBtn', function (event) {
        event.preventDefault();
        const $row = $(this).closest('.cart__card[data-cart-item]');
        Shopify.theme.cartFlow.change($row.attr('data-cart-item'), 0, $row);
        return false;
      });
    $('#cart_form').off('keydown.giftboxCart').on('keydown.giftboxCart', function (event) {
      if (event.key === 'Enter' && $(event.target).hasClass('quantity-input')) {
        event.preventDefault();
        $(event.target).trigger('change');
      }
    });
    document.dispatchEvent(new CustomEvent('cartUpdated', {detail: {message: 'Cart was updated'}}));
  },
  removeFromCart: function (lineID) {
    const $row = $('.cart__card[data-cart-item]').filter(function () {
      return $(this).attr('data-line-item') === String(lineID);
    }).first();
    if ($row.length) Shopify.theme.cartFlow.change($row.attr('data-cart-item'), 0, $row);
  },
  updateView: function () {
    const $current = $('.cart__form').closest('.shopify-section');
    const sectionId = $current.attr('id').replace(/^shopify-section-/, '');
    // Fetch the header count in parallel with the section HTML instead of after it.
    const cartRequest = $.ajax({url: Shopify.theme.cartFlow.root() + 'cart.js', dataType: 'json', cache: false});
    // Remember the add-on slider position so re-rendering does not jump it back to the start.
    const oldSlider = $current.find('.cart-upsell-collection').data('flickity');
    const sliderIndex = oldSlider ? oldSlider.selectedIndex : 0;
    return $.ajax({
      url: Shopify.theme.cartFlow.root() + 'cart',
      data: { section_id: sectionId },
      dataType: 'html', cache: false, timeout: 15000
    }).then(function (html) {
      const $next = $('<div>').append($.parseHTML(html, document, false));
      const $section = $next.find('#' + $current.attr('id'));
      if (!$section.length) throw new Error('Your cart was updated. Please refresh to see it.');
      const fields = {};
      $current.find('textarea, input[name^="attributes["]').each(function () { fields[this.name] = this.value; });
      $current.html($section.html());
      $current.find('textarea, input[name^="attributes["]').each(function () {
        if (Object.prototype.hasOwnProperty.call(fields, this.name)) this.value = fields[this.name];
      });
      const $slider = $current.find('.cart-upsell-collection');
      $slider.flickity({cellAlign: 'left', contain: true, freeScroll: true, prevNextButtons: true, pageDots: false, wrapAround: true});
      const newSlider = $slider.data('flickity');
      if (newSlider && newSlider.cells.length && sliderIndex > 0) {
        $slider.flickity('select', Math.min(sliderIndex, newSlider.cells.length - 1), false, true);
      }
      Shopify.theme.jsCart.init($current);
      return cartRequest.then(function (cart) {
        $('.header-cart__count').text(cart.item_count);
        $('.header-cart').toggleClass('has-cart-count', cart.item_count > 0);
      });
    });
  },
  unload: function () {
    $(document).off('.giftboxCart');
    $('#cart_form').off('.giftboxCart');
  }
};

// Rapid Cart is visually suppressed on /cart. Close it through its own control
// so its focus trap and wheel/touch listeners are released as well.
(function () {
  if (!document.body.classList.contains('cart')) return;
  function closeDrawer() {
    const panel = document.getElementById('rapi-cart-drawer-panel');
    if (panel && !panel.hidden) {
      const close = panel.querySelector('[data-rapi-close]');
      if (close) close.click();
    }
  }
  new MutationObserver(closeDrawer).observe(document.documentElement, {attributes: true, attributeFilter: ['class']});
  closeDrawer();

  // Add-on "Add to cart" queue: every click is accepted immediately and only the
  // clicked button shows a busy state. Adds are sent one after another (Shopify
  // rejects overlapping cart writes) and the cart is re-rendered once at the end.
  const queue = [];          // [{variantId, data}]
  const busy = {};           // variantId -> 'adding' | 'added'
  let running = false;

  function buttonsFor(variantId) {
    return $('.custom-cart-form form').filter(function () {
      return String($(this).find('input[name="id"]').val()) === variantId;
    }).find('[type="submit"]');
  }
  function paint(variantId) {
    const state = busy[variantId];
    const $buttons = buttonsFor(variantId);
    if (state === 'adding') $buttons.prop('disabled', true).attr('aria-busy', 'true').val('Adding…');
    else if (state === 'added') $buttons.prop('disabled', true).removeAttr('aria-busy').val('Added ✓');
    else $buttons.prop('disabled', false).removeAttr('aria-busy').val('Add to cart');
  }
  function showError(variantId, message) {
    const $form = buttonsFor(variantId).closest('form');
    $form.find('[role="alert"]').remove();
    $('<p role="alert">').text(message).appendTo($form);
  }

  function finish() {
    running = false;
    if (queue.length) { run(); return; } // clicks that came in during the refresh
    Shopify.theme.cartFlow.pending = false;
    Object.keys(busy).forEach(function (id) { if (busy[id] === 'added') delete busy[id]; });
    Object.keys(busy).forEach(paint); // re-apply states onto the freshly rendered buttons
    closeDrawer();
  }

  function run() {
    if (running) return;
    running = true;
    Shopify.theme.cartFlow.pending = true; // still blocks qty changes / checkout while the cart is being written
    (function next() {
      const job = queue.shift();
      if (!job) {
        Shopify.theme.jsCart.updateView().then(finish, function () {
          finish();
          window.location.reload();
        });
        return;
      }
      $.ajax({url: Shopify.theme.cartFlow.root() + 'cart/add.js', type: 'POST', data: job.data, dataType: 'json', timeout: 15000})
        .done(function () { busy[job.variantId] = 'added'; })
        .fail(function (error) {
          delete busy[job.variantId];
          showError(job.variantId, (error.responseJSON && error.responseJSON.description) || 'Could not add this item. Please try again.');
        })
        .always(function () { paint(job.variantId); next(); });
    })();
  }

  document.addEventListener('submit', function (event) {
    if (event.target.id === 'cart_form' && Shopify.theme.cartFlow.pending) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    const form = event.target.closest('.custom-cart-form form');
    if (!form) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const $form = $(form);
    const variantId = String($form.find('input[name="id"]').val());
    if (busy[variantId]) return; // this item is already queued / adding
    // A quantity change (not an add) is mid-flight: let it finish first.
    if (Shopify.theme.cartFlow.pending && !running) return;
    $form.find('[role="alert"]').remove();
    busy[variantId] = 'adding';
    queue.push({variantId: variantId, data: $form.serialize()});
    paint(variantId);
    run();
  }, true);
})();
